import { Component, EventEmitter, Input, Output}    from '@angular/core';

@Component({
  template: require('./transaction-header.component.html')
})
export class TransactionHeaderComponent {
  @Input() text: string;

  @Output() onClick: EventEmitter<any> = new EventEmitter();
}